import { useState, useCallback } from 'react';

export function usePermissionGuard<T = any>() {
    const [permissionError, setPermissionError] = useState(false);

    const guardedApiCall = useCallback((apiFn: () => Promise<T>) =>
        apiFn().catch((err) => {
            if (err?.response?.status === 403) {
                setPermissionError(true);
            }
            throw err;
        }), [setPermissionError]);

    return { permissionError, setPermissionError, guardedApiCall };
} 